<template>
    <!-- 添加课程 -->
    <div class="add-course">
        <el-page-header :content="$route.query.SourceId ? '编辑课程' : '新增课程' " @back="$router.go(-1)"/>
        <el-form size="medium" :model="addForm"
                 class="add-form"
                 ref="addProject" :inline="false" label-width="170px">
            <el-form-item label="名称" prop="SourceName" :rules="[{
                required: true,
                message: '请输入',
                trigger: 'change'
            }]">
                <el-input v-model="addForm.SourceName" placeholder="请输入名称"/>
            </el-form-item>
            <el-form-item label="上传课程" prop="VideoName"
                          :rules="[{ message: '请上传课程', trigger: 'change', required: true }]">
                <el-row type="flex" justify="space-between">
                    <el-input readonly :value="addForm.VideoName" placeholder="请上传课程"/>
                    <el-button type="primary" icon="el-icon-upload2"
                               style="margin-left: 30px"
                               @click.stop="handleUpload">上传课程
                    </el-button>
                </el-row>
                <div style="color: #f00">视频大小最大2GB</div>
                <el-progress :percentage="percentage" v-show="percentage !== 0"/>
            </el-form-item>
            <el-form-item label="课程封面" prop="ConverImg" v-if="addForm.VideoName">
                <el-upload
                    action=""
                    list-type="picture-card"
                    :http-request="uploadConverImg"
                    accept=".jpg,.png,.jpeg"
                    :limit="1"
                    :on-exceed="() => $message.warning('最多只能上传一张封面图')"
                    :on-remove="() => addForm.ConverImg = ''"
                    :file-list="fileList">
                    <i class="el-icon-plus"/>
                </el-upload>
            </el-form-item>
            <el-form-item label="课程类型" prop="SourceType"
                          :rules="[{required: true, message: '请选择课程', trigger: 'change'}]">
                <el-radio-group v-model="addForm.SourceType">
                    <el-radio v-for="(value, key) in PROJECT_TYPE_OPTIONS"
                              :label="parseInt(key)"
                              :key="key">{{ value }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="所属分类" prop="ClassId"
                          :rules="[{required: true, message: '请选择分类', trigger: 'change'}]">
                <medical-class-selector ref="select" v-model="addForm.ClassId" :add-all="false"/>
            </el-form-item>
            <el-form-item label="课程详情" prop="Content">
                <el-input type="textarea" resize="none"
                          v-model="addForm.Content"
                          :autosize="{ minRows: 4, maxRows: 6 }"/>
            </el-form-item>
            <el-form-item label="课程时间" prop="SourceTime"
                          :rules="[{
                           required: true, message: '请选择课程时间',
                           trigger: 'change', type: 'array'}]">
                <zj-date-picker disabled="before"
                                :is-show-form-item="false"
                                v-model="addForm.SourceTime"
                                type="datetimerange"/>
            </el-form-item>
            <el-form-item label="参与学员" prop="JoinMode"
                          :rules="[{required: true, message: '请选择参与学员', trigger: 'change'}]">
                <el-radio-group v-model="addForm.JoinMode">
                    <el-radio v-for="(value, key) in JOIN_MODE"
                              :label="parseInt(key)"
                              :key="key">{{ value }}
                    </el-radio>
                </el-radio-group>
                <div v-if="addForm.JoinMode === 1" style="margin-top: 20px">
                    <el-button type="primary"
                               @click.stop="handleSelect('JoinMode')">选择用户组/人员
                    </el-button>
                    <h4>已选择用户组</h4>
                    <el-table :data="groups.JoinMode">
                        <el-table-column label="组名称" prop="Name"/>
                        <el-table-column label="操作" width="100">
                            <template v-slot="{ $index }">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="groups.JoinMode.splice($index, 1)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <h4>已选择用户</h4>
                    <el-table :data="users.JoinMode">
                        <el-table-column
                            label="真实姓名"
                            prop="RealName"
                        ></el-table-column>
                        <el-table-column
                            label="账号"
                            prop="UserName"
                        ></el-table-column>
                        <el-table-column
                            label="电话"
                            prop="Telephone"
                        ></el-table-column>
                        <el-table-column
                            label="所属用户组"
                            prop="GroupName"
                        ></el-table-column>
                        <el-table-column label="操作" width="100">
                            <template v-slot="{$index}">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="users.JoinMode.splice($index, 1)"
                                >删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form-item>
            <el-form-item label="课程展示" prop="DisplayMode"
                          :rules="[{required: true, message: '请选择展示学员', trigger: 'change'}]">
                <el-radio-group v-model="addForm.DisplayMode">
                    <el-radio v-for="(value, key) in COURSE_SHOW"
                              :label="parseInt(key)"
                              :key="key">{{ value }}
                    </el-radio>
                </el-radio-group>
                <span style="color: rgba(0, 0, 0, .4); margin-left: 20px">没有选中的学员，将无法看见该课程</span>
                <div v-if="addForm.DisplayMode === 1" style="margin-top: 20px">
                    <el-button type="primary"
                               @click.stop="handleSelect('DisplayMode')">选择用户组/人员
                    </el-button>
                    <h4>已选择用户组</h4>
                    <el-table :data="groups.DisplayMode">
                        <el-table-column label="组名称" prop="Name"/>
                        <el-table-column label="操作" width="100">
                            <template v-slot="{ $index }">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="groups.DisplayMode.splice($index, 1)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <h4>已选择用户</h4>
                    <el-table :data="users.DisplayMode">
                        <el-table-column
                            label="真实姓名"
                            prop="RealName"
                        ></el-table-column>
                        <el-table-column
                            label="账号"
                            prop="UserName"
                        ></el-table-column>
                        <el-table-column
                            label="电话"
                            prop="Telephone"
                        ></el-table-column>
                        <el-table-column
                            label="所属用户组"
                            prop="GroupName"
                        ></el-table-column>
                        <el-table-column label="操作" width="100">
                            <template v-slot="{$index}">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="users.DisplayMode.splice($index, 1)"
                                >删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form-item>
            <el-form-item label="学分设置">
                <el-row type="flex" align="middle">
                    <span style="margin-right: 10px;">学员播放时长至少达</span>
                    <el-form-item prop="MinClassHours" style="width: 150px">
                        <el-input-number
                            style="width: 100%"
                            :min="1"
                            :max="Math.ceil(addForm.VideoTimeLength / 60)"
                            :placeholder="addForm.VideoTimeLength ? `最少1，最大${Math.ceil(addForm.VideoTimeLength / 60)}` : '时长'"
                            :controls="false" :precision="0" v-model="addForm.MinClassHours"/>
                    </el-form-item>
                    <span style="margin: 0 10px">分钟后，即完成课程，并获得学分</span>
                    <el-form-item prop="Credit" style="width: 100px" :rules="[{message: '请输入学分', required: true, trigger: 'blur', type: 'number'}]">
                        <el-input-number :controls="false"
                                         style="width: 100%"
                                         :min="0"
                                         placeholder="学分"
                                         :precision="0" v-model="addForm.Credit"/>
                    </el-form-item>
                </el-row>
            </el-form-item>
            <el-form-item style="text-align: center">
                <el-button type="primary" @click.stop="handleCreate">{{$route.query.SourceId ? "确定编辑" : "确定创建"}}</el-button>
            </el-form-item>
        </el-form>
        <select-member-dialog
            @select-user="onSelectUser"
            @select-group="onSelectGroup"
            :selected-group="currentGroup.map(item => item.ID)"
            :selected-member="currentUser"
            ref="selectMember"/>
    </div>
</template>

<script>
import { PROJECT_TYPE_OPTIONS } from "../config"
import { getAddFormInitVal, JOIN_MODE, COURSE_SHOW } from "./config"
import { getVideoInfo, uploadOfInput } from "@/utils";
import { uploadFile, createProject, getSourceDetail, uploadCourse } from "@/api/manage";
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import selectMemberDialog from "@/components/manager/create-exam/SelectMemberDialog";
import NP from "number-precision"
export default {
    name: "add",
    components: {
        MedicalClassSelector,
        selectMemberDialog
    },
    watch: {
        "addForm.JoinMode" (val) {
            if (val === 1) {
                this.currentSelectType = "JoinMode"
            }
        },
        "addForm.DisplayMode" (val) {
            if (val === 1) {
                this.currentSelectType = "DisplayMode"
            }
        }
    },
    data() {
        return {
            addForm: getAddFormInitVal(),
            PROJECT_TYPE_OPTIONS,
            JOIN_MODE,
            fileList: [],
            users: {
                JoinMode: [],
                DisplayMode: []
            },
            groups: {
                DisplayMode: [],
                JoinMode: []
            },
            COURSE_SHOW,
            currentSelectType: "JoinMode",
            percentage: 0
        }
    },
    computed: {
        currentUser () {
            return this.users[this.currentSelectType]
        },
        currentGroup () {
            return this.groups[this.currentSelectType] || []
        }
    },
    created() {
        this.getSourceDetail()
    },
    methods: {
        handleUpload() {
            uploadOfInput((file) => {
                if (!file) return
                // 视频大小最多500mb
                const fileSizeLimit = file.size > (1024 * 1024 * 500) * 4
                if (fileSizeLimit) return this.$message.error("视频大小最多2GB")
                const loading = this.$loading({
                    lock: true,
                    background: "rgba(0,0,0,.2)",
                    text: "上传中"
                })
                getVideoInfo(file, (poster, video) => {
                    const videoLength = Math.floor(video.duration)
                    this.addForm.VideoTimeLength = videoLength
                    uploadFile({ file: poster }).then(ConverImg => {
                        this.addForm.ConverImg = ConverImg
                        this.fileList = [{
                            name: "poster",
                            url: ConverImg,
                            status: "success"
                        }]
                        loading.close()
                    }).catch(e => {
                        loading.close()
                    })
                    uploadCourse({ file }, (progress) => {
                        this.percentage = NP.times(NP.round(progress.loaded / progress.total, 2), 100)
                    }).then(res => {
                        this.addForm.FileUrl = res
                        this.addForm.VideoName = file.name
                        this.addForm.MinClassHours = Math.ceil(videoLength / 60)
                    })
                })
            }, (err) => {
                this.$message.error(err.message || "选择文件失败")
            }, ".mp4")
        },
        handleSelect (type) {
            this.currentSelectType = type
            this.$refs.selectMember.open()
        },
        // 上传封面
        uploadConverImg(options) {
            uploadFile({ file: options.file }).then(res => {
                this.addForm.ConverImg = res
            })
        },
        // 处理确定创建
        handleCreate() {
            const { SourceTime, ...otherProps } = this.addForm
            this.$refs.addProject.validate((isPass) => {
                if (!isPass) return
                const isSpecify = this.addForm.JoinMode === 1 // 是否指定了人员
                const JoinGroups = this.groups.JoinMode.map(item => item.ID)
                const JoinPeoples = this.users.JoinMode.map(item => item.UserId)
                const DisplayGroups = this.groups.DisplayMode.map(item => item.ID)
                const DisplayPeoples = this.users.DisplayMode.map(item => item.UserId)
                // 如果选择指定机构人员，那么就必须选择
                if (isSpecify && JoinGroups.length === 0 && JoinPeoples.length === 0) {
                    return this.$message.warning("请选择用户组")
                }
                createProject(Object.assign(otherProps, {
                    StartTime: SourceTime[0],
                    EndTime: SourceTime[1],
                    JoinGroups,
                    DisplayGroups,
                    JoinPeoples,
                    DisplayPeoples,
                    SourceId: this.SourceId
                })).then(res => {
                    if (this.SourceId) {
                        this.$message.success("编辑成功")
                    } else {
                        this.$message.success("新增课程成功")
                    }
                    this.$router.replace("/manage/resource/course")
                })
            })
        },
        // 选择用户
        onSelectUser(val) {
            this.$set(this.users, this.currentSelectType, val)
        },
        // 选择用户组
        onSelectGroup(val) {
            this.$set(this.groups, this.currentSelectType, val)
        },
        // 获取课程详情
        getSourceDetail () {
            this.SourceId = this.$route.query.SourceId
            if (!this.SourceId) return
            getSourceDetail(this.SourceId).then(res => {
                this.addForm.SourceTime = [res.StartTime, res.EndTime]
                this.users.JoinMode = res.JoinPeoples.map(item => Object.assign(item, { UserId: item.Id }))
                this.groups.JoinMode = res.JoinGroups.map(item => Object.assign(item, { ID: item.Id }))
                this.users.DisplayMode = (res.DisplayPeoples || []).map(item => Object.assign(item, { UserId: item.Id }))
                this.groups.DisplayMode = (res.DisplayGroups || []).map(item => Object.assign(item, { ID: item.Id }))
                this.addForm.ConverImg = res.ConverImg
                this.addForm.FileUrl = res.FileUrl
                this.addForm.VideoName = res.VideoName || "无"
                this.addForm.Content = res.Content
                this.addForm.Credit = res.Credit
                this.addForm.MinClassHours = res.MinClassHours
                this.addForm.ClassId = res.ClassId
                this.addForm.SourceName = res.SourceName
                this.addForm.SourceType = res.SourceType
                this.addForm.JoinMode = res.JoinMode
                this.addForm.DisplayMode = res.DisplayMode
                this.addForm.VideoTimeLength = res.VideoTimeLength
                this.fileList = [{
                    name: "poster",
                    url: res.ConverImg,
                    status: "success"
                }]
            })
        }
    }
}
</script>

<style scoped lang="less">
.add-course {
    padding: 30px 40px;
    box-sizing: border-box;
}

.add-form {
    width: 90%;
    margin: 60px auto 0;
}
</style>
